import { importWithChunkReload } from '@/lib/chunk-reload';

// Translation catalogs are lazy chunks too. Recover confirmed stale releases
// before their import failure escapes a language-change promise.
export function loadLocaleModules(lang, modules, recoveryOptions) {
  const loaders = Object.entries(modules)
    .filter(([path]) => path.split('/').at(-2) === lang)
    .map(([, loader]) =>
      importWithChunkReload(loader, recoveryOptions).then(
        (mod) => mod.default || mod,
      ),
    );
  return Promise.all(loaders);
}
